export default "__VITE_ASSET__fb22106b__"